import React from 'react';
import { Grid, Avatar, Typography, makeStyles } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CardWitTitle from './CardWithTitle';

function MemberAvatar({ user, ...props }) {

  const useStyles = makeStyles(theme => ({
    avatar: {
      width: '100%',
      height: theme.spacing(60),
      margin: '0 auto',
    },
  }));
  const classes = useStyles();

  return (
    <React.Fragment>
      <CardWitTitle title="Selfie">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Avatar
              alt={
                user?.firstName +
                " " +
                user?.lastName
              }
              src={user?.photoURL}
              variant="rounded"
              className={classes.avatar}
            />
          </Grid>
          <Grid item xs={12}>
            {user?.photoEditAllowed ?
              <>
                <LockOpenIcon color='primary' fontSize='large' />
                <Typography variant='body1' component='p'>
                  Användare kan ladda upp ny bild
                </Typography>
              </> :
              <>
                <LockIcon color='primary' fontSize='large' />
                <Typography variant='body1' component='p'>
                  För att användare
                  ska kunna ladda upp
                  ny bild behöver
                  medlemskap
                  avaktiveras
                </Typography>
              </>}
          </Grid>
        </Grid>
      </CardWitTitle>
    </React.Fragment>
  );

}

export default MemberAvatar;